import { type CargoBoxValidateRequest as SchemaCargoBoxValidateRequest } from '../schemas/CargoBoxValidateRequest';
import { type CargoBoxValidateResponse as SchemaCargoBoxValidateResponse } from '../schemas/CargoBoxValidateResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const ValidateCargoBoxesContentType = 'application/json' as const;
export type ValidateCargoBoxesRequest = SchemaCargoBoxValidateRequest;
export type ValidateCargoBoxesResponses = {
    '200': {
        'application/json': SchemaCargoBoxValidateResponse;
    };
};
export type ValidateCargoBoxesResponseSuccess = ValidateCargoBoxesResponses['200']['application/json'];
export type ValidateCargoBoxesSearchParams = undefined;
export type ValidateCargoBoxesPathParameters = undefined;
export const ValidateCargoBoxesUrl = '/cargoboxes/validate' as const;
export const ValidateCargoBoxesMethod = 'POST' as const;
export const getValidateCargoBoxesUrl = (_params?: ValidateCargoBoxesPathParameters) => ValidateCargoBoxesUrl;
